// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: 'https://aptsiztaas.eastus.cloudapp.azure.com:3001',
  keyCloakRedirectUrl: 'https://aptsiztaas.eastus.cloudapp.azure.com',
  keyCloakUri: 'https://aptsiztaas.eastus.cloudapp.azure.com/auth',
  keyCloakRealm: 'aptsi-ztaas',
  keyCloakClientId:'angular-web-client',
  docsUrlRedirectUrl: 'https://aptsiztaas.eastus.cloudapp.azure.com/docs'
};
